import namespace from "@rdfjs/namespace";
export const sem = namespace("http://semanticweb.cs.vu.nl/2009/11/sem/");
